import React from "react";
import { useSelector } from "react-redux";

import RequireAccount from "../../../../account/components/RequireAccount";
import { RootState } from "../../../../../redux/store";
import {
  resolveSignInFirst,
  useActiveProductCategory,
} from "../../../../../util/categoryConfig";

/**
 * #3069: a category that asks who the customer is before its first screen
 * (ADR-0026 §Z). The whole flow sits behind the account sign-in, so the room
 * list already follows the session, and the login returns to the same URL.
 *
 * UX, not an access boundary: what someone may book is decided server-side
 * (`mayBookRoom`, ADR-0020). An entry without the category in the URL (a
 * re-book, a link from another room's week) is not gated.
 */
const SignInFirstGate: React.FC<{ useCase: string; children: React.ReactElement }> = ({
  useCase,
  children,
}) => {
  const categoryKey = useActiveProductCategory();
  const signInFirst = useSelector((state: RootState) =>
    resolveSignInFirst(state.tenantConfig?.config, useCase, categoryKey)
  );
  return signInFirst ? <RequireAccount>{children}</RequireAccount> : children;
};

export default SignInFirstGate;
